<template>
  <div style="text-align: center">
    <div>
      <h2 class="mb-2">{{ errorTitle }}</h2>
    </div>
    <div>
      <img
        src="../../../assets/images/error.svg"
        width="150"
        class="mb4 mt-4"
      />
    </div>
    <div style="margin-top: 20px">
      <p>
        {{ errorMessage }}
      </p>
    </div>
    <slot v-slot="messageSuffix"></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    title: {
      type: String
    },
    message: {
      type: String
    }
  },
  computed: {
    errorTitle() {
      return this.title || "Well, this is embarrassing.";
    },
    errorMessage() {
      return this.message || "Something went wrong. Sorry about this.";
    }
  }
};
</script>
